import React from 'react'
import { defineMessage, FormattedMessage } from 'react-intl'
import { Linking } from 'react-native'

import { useTheme } from 'styled-components/native'

import { IS_PRODUCTION } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import {
  CustomerSubpopulations,
  GetCustomerCopyFunc,
} from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { Link } from '../atoms/link/Link'
import { ThemeType } from '../utils/themes/ThemeProvider'

export const vca: GetCustomerCopyFunc = () => {
  // Define subpopulations outside of the theme-dependent code
  const subpopulations: CustomerSubpopulations = {
    header: defineMessage({
      defaultMessage: 'Which type of VCA member are you?',
      description: 'VCA subpopulation redirection header',
    }),
    options: [
      {
        label: defineMessage({
          defaultMessage: 'Associate',
          description: 'VCA Associate member label',
        }),
        description: defineMessage({
          defaultMessage: 'I am an Associate of VCA',
          description: 'VCA Associate member description',
        }),
      },
      {
        label: defineMessage({
          defaultMessage: 'Dependent',
          description: 'VCA Dependent member label',
        }),
        description: defineMessage({
          defaultMessage:
            'I am a spouse/domestic partner or dependent (over the age of 18) of a VCA Associate and am enrolled in an Anthem Health Plan or I am an Associate of VCA seeking care for a dependent under 18 years old who is enrolled in an Anthem Health Plan.',
          description: 'VCA Dependent member description',
        }),
      },
    ],
  }
  const subpopulations_lctTeens: CustomerSubpopulations = {
    header: defineMessage({
      defaultMessage: 'Which type of VCA member are you?',
      description: 'VCA subpopulation redirection header',
    }),
    options: [
      {
        label: defineMessage({
          defaultMessage: 'Associate',
          description: 'VCA Associate member label',
        }),
        description: defineMessage({
          defaultMessage: 'I am an Associate of VCA',
          description: 'VCA Associate member description',
        }),
      },
      {
        label: defineMessage({
          defaultMessage: 'Dependent',
          description: 'VCA Dependent member label',
        }),
        description: defineMessage({
          defaultMessage:
            'I am a spouse/domestic partner or dependent (over the age of 13) of a VCA Associate and am enrolled in an Anthem Health Plan or I am an Associate of VCA seeking care for a dependent under 18 years old who is enrolled in an Anthem Health Plan.',
          description: 'VCA Dependent member description',
        }),
      },
    ],
  }
  const dependentIneligibleUrl = IS_PRODUCTION
    ? 'https://vca-2.lyrahealth.com/register/connect'
    : 'https://vca-2.staging.lyrahealth.com/register/connect'

  // Create a component that uses the theme context
  const DependentIneligibleText = () => {
    const { colors } = useTheme() as ThemeType

    return (
      <FormattedMessage
        defaultMessage='If you are a spouse/domestic partner or dependent (over the age of 13) of a VCA Associate and are enrolled in an Anthem Health Plan, or an Associate of VCA seeking care for a dependent under 18 years old who is enrolled in an Anthem Health Plan, please register {link}.'
        description='VCA dependent ineligible text'
        values={{
          link: (
            <Link
              text={<FormattedMessage defaultMessage='here' description='Link text for VCA dependent registration' />}
              color={colors.textWarning}
              underline
              onPress={() => {
                Linking.openURL(dependentIneligibleUrl)
              }}
            />
          ),
        }}
      />
    )
  }

  return {
    subpopulations,
    subpopulations_lctTeens,
    dependentIneligibleText: <DependentIneligibleText />,
  }
}
